module.exports = __webpack_public_path__ + "img/step4a-fr.e85ef284.webp";